import makeid from "../../../Universal/Makeid";

export const formatUserNowTime = () =>
  new Date().toLocaleString("en-US", {
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit",
    hour12: false,
  });

export const makeIds = () => {
  const k = makeid(18);
  return { lid: `${k}||like`, dlid: `${k}||dislike`, cid: `${k}||catalog` };
};

export const createQuestionEntry = (question) => ({
  type: "question",
  id: makeid(12),
  question,
});

export const createAnswerEntry = (answer, agent, extras = {}) => ({
  type: "answer",
  id: makeid(12),
  answer,
  agent,
  docIds: extras.docIds || [],
  sources: extras.sources || [],
  documentId: extras.documentId || "",
  answerType: extras.answerType || "",
  citations: extras.citations || [],
  relatedSources: extras.relatedSources || [],
  freshStream: extras.freshStream || false,
  isError: extras.isError || false,
  retryPayload: extras.retryPayload || null,
  like: extras.like || false,
  dislike: extras.dislike || false,
  catalog: extras.catalog || false,
  ...makeIds(),
});

export const newUUID = () => {
  if (typeof crypto !== "undefined" && crypto.randomUUID)
    return crypto.randomUUID();
  return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, (c) => {
    const r = (Math.random() * 16) | 0;
    const v = c === "x" ? r : (r & 0x3) | 0x8;
    return v.toString(16);
  });
};
